/** This Widget can create multiple inputs from arrays*/
import React, { PureComponent } from "react";

import PropTypes from "prop-types";
import { FormGroup } from "react-bootstrap-3";
import styled from "styled-components";
import { defineMessages, FormattedMessage } from "react-intl";
const messages = defineMessages({
  selectAll: {
    id: "app.smartSelector.selectAll",
    description: "Select All",
    defaultMessage: "Select All",
  },
  deselectAll: {
    id: "app.smartSelector.deselectAll",
    description: "Deselect All",
    defaultMessage: "Deselect All",
  },
});

const FormGroupStyled = styled(({ multiCheckboxType, disabled, ...props }) => (
  <FormGroup {...props} />
))`
  ${props => (props.disabled ? `pointer-events: none;` : ``)}
  .checkbox label {
    ${props =>
      props.multiCheckboxType === "LIST"
        ? "display: block !important"
        : "display: inline-block !important"};
  }
`;

const SelectAllNoneContainer = styled.div`
  display: flex;
  margin-top: -5px;
  cursor: default !important;
`;

const CheckboxesContainer = styled.div`
  display: flex;
  div {
    margin-top: 10px;
    margin-right: 10px;
  }

  .c-checkbox:hover em {
    border-color: red !important;
  }
`;

const SelectStatusCheckboxes = styled.div`
  background-color: #ffffff;
  border: 0;
  cursor: pointer;
  color: lightskyblue;
  text-decoration: underline;
`;

const ExportableLink = styled.div`
  background-color: #ffffff;
  border: 0;
  cursor: pointer;
  color: lightskyblue;
  text-decoration: underline;
`;

const DisplaySecondaryLabel = styled.span`
  font-weight: 600;
`;

const LabelWrapper = styled.span`
  display: inline-block;
  cursor: pointer;
  margin: 0 10px 5px 0;
`;

const CheckboxContentWrapper = styled.div`
  cursor: default !important;
`;

const MultiCheckboxContainer = styled.div`
  display: ${props => (props.horizontal ? "flex" : "inherit")};
`;

const isChecked = ({ value, ticker }) => {
  if ((value && value.indexOf(ticker) >= 0) || value === ticker || false) {
    return true;
  } else {
    return false;
  }
};

class MultiCheckboxGroup extends PureComponent {
  /** This function deletes or pushes a ticker based in the changes from the checkboxes*/
  handleOnChange = ({ event, ticker }) => {
    const val = this.props.value || [];
    const newVal = event.target.checked ? [...val, ticker] : val.filter(it => it !== ticker);
    this.props.onChange({
      value: newVal,
      field: this.props.field.fieldName,
    });
  };

  setTrueAllCheckboxes = () => {
    const { options, entity } = this.props.field;

    const checkBoxList =
      (this.props.relatedEntities && this.props.relatedEntities[entity]) || options || [];

    this.props.onChange({
      value: checkBoxList.map(value => value.ticker),
      field: this.props.field.fieldName,
    });
  };
  setFalseAllCheckboxes = () => {
    this.props.onChange({
      value: [],
      field: this.props.field.fieldName,
    });
  };

  render() {
    const { value, relatedEntities, locale, className, horizontal } = this.props;
    const {
      description,
      options,
      disabled,
      /** Enables the render buttons to set all checboxes to true or false*/
      selectables,
      /** Texts that will render to execute the set all true or false*/
      exportable,
      entity,
      entityDisplay,
      entitySecondaryDisplay,
      entitySecondaryDisplayTranslated,
      mapping,
      multiCheckboxType,
    } = this.props.field;

    const checkBoxList = (relatedEntities && relatedEntities[entity]) || options || [];

    return (
      <div className={`${className} multicheckboxGroup`}>
        <FormGroupStyled multiCheckboxType={multiCheckboxType} disabled={disabled}>
          <div className="multicheckbox checkbox c-checkbox needsclick">
            <div>
              {description}
              <MultiCheckboxContainer
                className={"multicheckboxes-container"}
                horizontal={horizontal}>
                {selectables && (
                  <SelectAllNoneContainer>
                    <SelectStatusCheckboxes onClick={this.setTrueAllCheckboxes}>
                      <FormattedMessage {...messages.selectAll} />
                    </SelectStatusCheckboxes>
                    &nbsp;/&nbsp;
                    <SelectStatusCheckboxes onClick={this.setFalseAllCheckboxes}>
                      <FormattedMessage {...messages.deselectAll} />
                    </SelectStatusCheckboxes>
                  </SelectAllNoneContainer>
                )}
                {exportable && (
                  <ExportableLink>
                    &nbsp;/&nbsp;
                    <div>export</div>
                  </ExportableLink>
                )}
                {checkBoxList.map((option, index) => {
                  let displayLabel =
                    (mapping && mapping[locale] && mapping[locale][option[entityDisplay]]) ||
                    option[entityDisplay] ||
                    option.name;

                  let displaySecondaryLabel = option[entitySecondaryDisplay];

                  if (entitySecondaryDisplayTranslated && option.translations) {
                    displaySecondaryLabel = option.translations.find(
                      translation => translation.language === locale
                    );

                    displaySecondaryLabel = displaySecondaryLabel
                      ? displaySecondaryLabel.title
                      : option.translations[0]
                      ? option.translations[0].title
                      : null;
                  }

                  return (
                    /**TODO: Change key index to be unique */
                    <CheckboxContentWrapper>
                      <LabelWrapper>
                        <label key={index} className="needsclick">
                          <CheckboxesContainer>
                            <input
                              disabled={disabled}
                              type="checkbox"
                              checked={isChecked({
                                value,
                                ticker: option.ticker,
                              })}
                              className="needsclick-input"
                              onChange={event => {
                                this.handleOnChange({
                                  event,
                                  ticker: option.ticker,
                                });
                              }}
                            />
                            <em className="fa fa-check" />
                            {displayLabel}
                            {displaySecondaryLabel && (
                              <DisplaySecondaryLabel>
                                {": "}
                                {displaySecondaryLabel}
                              </DisplaySecondaryLabel>
                            )}
                          </CheckboxesContainer>
                        </label>
                      </LabelWrapper>
                    </CheckboxContentWrapper>
                  );
                })}
              </MultiCheckboxContainer>
            </div>
          </div>
        </FormGroupStyled>
      </div>
    );
  }
}

MultiCheckboxGroup.propTypes = {
  /** Field contains the props writted in the ModuleDefinition.js*/
  field: PropTypes.object,
  /** red message when an error occurs */
  formErrors: PropTypes.object,
  /** indicates if an error has occured */
  hasErrors: PropTypes.bool,
  /** this contains the function called when the input changes*/
  onChange: PropTypes.func,
};

export default MultiCheckboxGroup;
